import { ErrorComponent } from "components";

interface Blok {
  component: string;
}

interface ErrorComponentAdapterProps {
  blok: Blok;
}

const ErrorComponentAdapter = ({ blok: { component } }: ErrorComponentAdapterProps) => (
  <ErrorComponent text={`The component ${component.toUpperCase()} has not been created yet.`} />
);

export default ErrorComponentAdapter;
